import { FC, useEffect, useState } from 'react';
import Text from '@/components/text';
import Button from '@/components/button';
import Illustration from '@/components/illustration';
import PageCard from '@/components/page-card';
import { LoadState } from '@/lib/helpers';
import { addError } from '@/lib/datadog';

interface Props {
  error?: Error;
}

const ErrorPage: FC<Props> = ({ error }) => {
  const [loadState, setLoadState] = useState<LoadState>('unloaded');

  useEffect(() => {
    if (!error) {
      setLoadState('loaded');
      return;
    }

    if (loadState !== 'unloaded') {
      return;
    }

    const renderError = new Error(error.message);
    renderError.name = `ReactRenderingError`;
    renderError.stack = error.stack;
    renderError.cause = error;
    addError(renderError);

    setLoadState('loaded');
  }, [loadState, error]);

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <PageCard width={700}>
      <Illustration name="server-error" />
      <Text bold size="x-large">
        Unexpected Error
      </Text>
      <Text>There was an unexpected error. Please try again later.</Text>

      <Button label="Go back to Homepage" onClick={handleGoHome} />
    </PageCard>
  );
};

export default ErrorPage;
